import { Dialog, DialogBackdrop, Transition, TransitionChild } from '@headlessui/react';
import { FC, Fragment } from 'react';
import { FiX } from 'react-icons/fi';
import strings from '../roster.translations';
import { OptimisationEvaluationCard } from './OptimisationEvaluationCard';

interface OptimisationHistoryModalProps {
  open: boolean;
  onClose: () => void;
  locationId: number;
  startDate: Date;
  endDate: Date;
}

export const OptimisationHistoryModal: FC<OptimisationHistoryModalProps> = ({
  open,
  onClose,
  locationId,
  startDate,
  endDate
}) => {
  return (
    <Transition show={open} as={Fragment}>
      <Dialog as="div" static open={open} className="fixed inset-0 z-[10000000] overflow-y-auto" onClose={onClose}>
        <div className="flex min-h-screen items-center justify-center p-4 text-center">
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <DialogBackdrop className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />
          </TransitionChild>

          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:scale-95"
          >
            <div className="relative inline-flex max-h-[90vh] w-full transform flex-col rounded-lg bg-primary-std text-left align-middle shadow-xl transition-all sm:w-[95vw] xl:max-w-[96rem]">
              <div className="relative shrink-0 border-b border-slate-200 px-8 py-6">
                <h2 className="pr-8 text-left text-xl font-semibold text-slate-900">
                  {strings.optimiseRosters.evaluation.title}
                </h2>
                <button className="absolute top-6 right-8" onClick={onClose}>
                  <FiX className="h-6 w-6 sm:h-8 sm:w-8" />
                </button>
              </div>

              <div className="overflow-y-auto px-8 py-6">
                <OptimisationEvaluationCard
                  locationId={locationId}
                  startDate={startDate}
                  endDate={endDate}
                  embedded
                />
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
};
